import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PrintReportJSON } from '@compiere-ws/models/compiere-print-report-json';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PrintReportService {
  private urlPrint: string;

  constructor(private http: HttpClient) {}

  printReport(dataForReport: PrintReportJSON): Observable<any> {
    this.urlPrint = environment.config.backend.ws.url + environment.config.backend.ws.paths['printReport'];
    return this.http.post(this.urlPrint, dataForReport);
  }

  downloadReport(urlDownload: string): Observable<any> {
    return this.http.get<any>(environment.config.backend.ws.url + urlDownload.replace(/\\/g, '/'), {
      responseType: 'blob' as 'json',
      observe: 'response',
    });
  }
}
